import './App.css';
import { useState } from 'react'
import MainView from './MainView';
import Imagemaptesti2 from './imagemaptesti2';
import { Example } from './kokeilut/testi';
import './pelidemo.css'
import 'react-tooltip/dist/react-tooltip.css'

import Magnifier from './additionalComponents/magnifier.tsx'



function App() {






  return (
    <div>

      {/* <h3>wtf</h3> */}
      <MainView />
      {/* <Grid_harj_main /> */}
      {/* <Magnifier /> */}
      {/* <Example /> */}
      {/* <Imagemaptesti2 /> */}


    </div>
  );
}



export default App;
